import { Box, Typography, styled } from '@mui/material';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { FC } from 'react';
import shaka from 'shaka-player';
import { t } from 'i18next';

type ShakaErrors = Record<shaka.util.Error.Code, string>;
type ErrorMessageProps = {
  code?: shaka.util.Error.Code;
};

const shakaErrors = Object.entries(shaka.util.Error.Code).reduce<ShakaErrors>(
  (acc, [k, v]) => ({ ...acc, [v]: k }),
  {} as ShakaErrors,
);

const translateErrorCode = (code: shaka.util.Error.Code) => shakaErrors[code];

const ErrorBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 1,
  gap: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.common.black,
  color: theme.palette.common.white,
}));

export const ErrorMessage: FC<ErrorMessageProps> = ({ code = -1 }) => {
  return (
    <ErrorBox>
      <ErrorIcon />
      <Typography>{`${translateErrorCode(code) ?? t('player.errors.unknown')}  (${code})`}</Typography>
    </ErrorBox>
  );
};
